"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SegmentData_1 = __importDefault(require("../entity/SegmentData"));
const SegmentStub_1 = __importDefault(require("./SegmentStub"));
class SegmentDataStub extends SegmentData_1.default {
    constructor({ label = 'Test', device = [new SegmentStub_1.default(), new SegmentStub_1.default(), new SegmentStub_1.default()], gender = [new SegmentStub_1.default(), new SegmentStub_1.default(), new SegmentStub_1.default()], ageGroup = [new SegmentStub_1.default(), new SegmentStub_1.default(), new SegmentStub_1.default()], } = {}) {
        super({ label, device, gender, ageGroup });
    }
}
exports.default = SegmentDataStub;
